/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as AppRouteImport } from './routes/_app';
import { Route as AuthRouteImport } from './routes/auth';
import { Route as AppOnboardingRouteImport } from './routes/_app.onboarding';
import { Route as AppSettingsRouteImport } from './routes/_app.settings';
import { Route as ShareTokenRouteImport } from './routes/share.$token';
import { Route as AppDDictionaryIdRouteImport } from './routes/_app.d.$dictionaryId';
import { Route as AppDictionariesNewRouteImport } from './routes/_app.dictionaries.new';
import { Route as AppDDictionaryIdIndexRouteImport } from './routes/_app.d.$dictionaryId.index';
import { Route as AppDDictionaryIdAddRouteImport } from './routes/_app.d.$dictionaryId.add';
import { Route as AppDDictionaryIdSearchRouteImport } from './routes/_app.d.$dictionaryId.search';
import { Route as AppDDictionaryIdSettingsRouteImport } from './routes/_app.d.$dictionaryId.settings';
import { Route as AppDDictionaryIdLHeadwordRouteImport } from './routes/_app.d.$dictionaryId.l.$headword';
import { Route as AppDDictionaryIdWEntryIdIndexRouteImport } from './routes/_app.d.$dictionaryId.w.$entryId.index';
import { Route as AppDDictionaryIdWEntryIdEditRouteImport } from './routes/_app.d.$dictionaryId.w.$entryId.edit';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any);
const AppOnboardingRoute = AppOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AppRoute,
} as any);
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any);
const ShareTokenRoute = ShareTokenRouteImport.update({
  id: '/share/$token',
  path: '/share/$token',
  getParentRoute: () => rootRouteImport,
} as any);
const AppDDictionaryIdRoute = AppDDictionaryIdRouteImport.update({
  id: '/d/$dictionaryId',
  path: '/d/$dictionaryId',
  getParentRoute: () => AppRoute,
} as any);
const AppDictionariesNewRoute = AppDictionariesNewRouteImport.update({
  id: '/dictionaries/new',
  path: '/dictionaries/new',
  getParentRoute: () => AppRoute,
} as any);
const AppDDictionaryIdIndexRoute = AppDDictionaryIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDDictionaryIdRoute,
} as any);
const AppDDictionaryIdAddRoute = AppDDictionaryIdAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => AppDDictionaryIdRoute,
} as any);
const AppDDictionaryIdSearchRoute = AppDDictionaryIdSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AppDDictionaryIdRoute,
} as any);
const AppDDictionaryIdSettingsRoute =
  AppDDictionaryIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AppDDictionaryIdRoute,
  } as any);
const AppDDictionaryIdLHeadwordRoute =
  AppDDictionaryIdLHeadwordRouteImport.update({
    id: '/l/$headword',
    path: '/l/$headword',
    getParentRoute: () => AppDDictionaryIdRoute,
  } as any);
const AppDDictionaryIdWEntryIdIndexRoute =
  AppDDictionaryIdWEntryIdIndexRouteImport.update({
    id: '/w/$entryId/',
    path: '/w/$entryId/',
    getParentRoute: () => AppDDictionaryIdRoute,
  } as any);
const AppDDictionaryIdWEntryIdEditRoute =
  AppDDictionaryIdWEntryIdEditRouteImport.update({
    id: '/w/$entryId/edit',
    path: '/w/$entryId/edit',
    getParentRoute: () => AppDDictionaryIdRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/auth': typeof AuthRoute;
  '/onboarding': typeof AppOnboardingRoute;
  '/settings': typeof AppSettingsRoute;
  '/share/$token': typeof ShareTokenRoute;
  '/d/$dictionaryId': typeof AppDDictionaryIdRouteWithChildren;
  '/dictionaries/new': typeof AppDictionariesNewRoute;
  '/d/$dictionaryId/add': typeof AppDDictionaryIdAddRoute;
  '/d/$dictionaryId/search': typeof AppDDictionaryIdSearchRoute;
  '/d/$dictionaryId/settings': typeof AppDDictionaryIdSettingsRoute;
  '/d/$dictionaryId/': typeof AppDDictionaryIdIndexRoute;
  '/d/$dictionaryId/l/$headword': typeof AppDDictionaryIdLHeadwordRoute;
  '/d/$dictionaryId/w/$entryId/edit': typeof AppDDictionaryIdWEntryIdEditRoute;
  '/d/$dictionaryId/w/$entryId/': typeof AppDDictionaryIdWEntryIdIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/auth': typeof AuthRoute;
  '/onboarding': typeof AppOnboardingRoute;
  '/settings': typeof AppSettingsRoute;
  '/share/$token': typeof ShareTokenRoute;
  '/dictionaries/new': typeof AppDictionariesNewRoute;
  '/d/$dictionaryId/add': typeof AppDDictionaryIdAddRoute;
  '/d/$dictionaryId/search': typeof AppDDictionaryIdSearchRoute;
  '/d/$dictionaryId/settings': typeof AppDDictionaryIdSettingsRoute;
  '/d/$dictionaryId': typeof AppDDictionaryIdIndexRoute;
  '/d/$dictionaryId/l/$headword': typeof AppDDictionaryIdLHeadwordRoute;
  '/d/$dictionaryId/w/$entryId/edit': typeof AppDDictionaryIdWEntryIdEditRoute;
  '/d/$dictionaryId/w/$entryId': typeof AppDDictionaryIdWEntryIdIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/_app': typeof AppRouteWithChildren;
  '/auth': typeof AuthRoute;
  '/_app/onboarding': typeof AppOnboardingRoute;
  '/_app/settings': typeof AppSettingsRoute;
  '/share/$token': typeof ShareTokenRoute;
  '/_app/d/$dictionaryId': typeof AppDDictionaryIdRouteWithChildren;
  '/_app/dictionaries/new': typeof AppDictionariesNewRoute;
  '/_app/d/$dictionaryId/add': typeof AppDDictionaryIdAddRoute;
  '/_app/d/$dictionaryId/search': typeof AppDDictionaryIdSearchRoute;
  '/_app/d/$dictionaryId/settings': typeof AppDDictionaryIdSettingsRoute;
  '/_app/d/$dictionaryId/': typeof AppDDictionaryIdIndexRoute;
  '/_app/d/$dictionaryId/l/$headword': typeof AppDDictionaryIdLHeadwordRoute;
  '/_app/d/$dictionaryId/w/$entryId/edit': typeof AppDDictionaryIdWEntryIdEditRoute;
  '/_app/d/$dictionaryId/w/$entryId/': typeof AppDDictionaryIdWEntryIdIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/auth'
    | '/onboarding'
    | '/settings'
    | '/share/$token'
    | '/d/$dictionaryId'
    | '/dictionaries/new'
    | '/d/$dictionaryId/add'
    | '/d/$dictionaryId/search'
    | '/d/$dictionaryId/settings'
    | '/d/$dictionaryId/'
    | '/d/$dictionaryId/l/$headword'
    | '/d/$dictionaryId/w/$entryId/edit'
    | '/d/$dictionaryId/w/$entryId/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/auth'
    | '/onboarding'
    | '/settings'
    | '/share/$token'
    | '/dictionaries/new'
    | '/d/$dictionaryId/add'
    | '/d/$dictionaryId/search'
    | '/d/$dictionaryId/settings'
    | '/d/$dictionaryId'
    | '/d/$dictionaryId/l/$headword'
    | '/d/$dictionaryId/w/$entryId/edit'
    | '/d/$dictionaryId/w/$entryId';
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/auth'
    | '/_app/onboarding'
    | '/_app/settings'
    | '/share/$token'
    | '/_app/d/$dictionaryId'
    | '/_app/dictionaries/new'
    | '/_app/d/$dictionaryId/add'
    | '/_app/d/$dictionaryId/search'
    | '/_app/d/$dictionaryId/settings'
    | '/_app/d/$dictionaryId/'
    | '/_app/d/$dictionaryId/l/$headword'
    | '/_app/d/$dictionaryId/w/$entryId/edit'
    | '/_app/d/$dictionaryId/w/$entryId/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AppRoute: typeof AppRouteWithChildren;
  AuthRoute: typeof AuthRoute;
  ShareTokenRoute: typeof ShareTokenRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_app': {
      id: '/_app';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AppRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/auth': {
      id: '/auth';
      path: '/auth';
      fullPath: '/auth';
      preLoaderRoute: typeof AuthRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_app/onboarding': {
      id: '/_app/onboarding';
      path: '/onboarding';
      fullPath: '/onboarding';
      preLoaderRoute: typeof AppOnboardingRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/settings': {
      id: '/_app/settings';
      path: '/settings';
      fullPath: '/settings';
      preLoaderRoute: typeof AppSettingsRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/share/$token': {
      id: '/share/$token';
      path: '/share/$token';
      fullPath: '/share/$token';
      preLoaderRoute: typeof ShareTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_app/d/$dictionaryId': {
      id: '/_app/d/$dictionaryId';
      path: '/d/$dictionaryId';
      fullPath: '/d/$dictionaryId';
      preLoaderRoute: typeof AppDDictionaryIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/dictionaries/new': {
      id: '/_app/dictionaries/new';
      path: '/dictionaries/new';
      fullPath: '/dictionaries/new';
      preLoaderRoute: typeof AppDictionariesNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/d/$dictionaryId/': {
      id: '/_app/d/$dictionaryId/';
      path: '/';
      fullPath: '/d/$dictionaryId/';
      preLoaderRoute: typeof AppDDictionaryIdIndexRouteImport;
      parentRoute: typeof AppDDictionaryIdRoute;
    };
    '/_app/d/$dictionaryId/add': {
      id: '/_app/d/$dictionaryId/add';
      path: '/add';
      fullPath: '/d/$dictionaryId/add';
      preLoaderRoute: typeof AppDDictionaryIdAddRouteImport;
      parentRoute: typeof AppDDictionaryIdRoute;
    };
    '/_app/d/$dictionaryId/search': {
      id: '/_app/d/$dictionaryId/search';
      path: '/search';
      fullPath: '/d/$dictionaryId/search';
      preLoaderRoute: typeof AppDDictionaryIdSearchRouteImport;
      parentRoute: typeof AppDDictionaryIdRoute;
    };
    '/_app/d/$dictionaryId/settings': {
      id: '/_app/d/$dictionaryId/settings';
      path: '/settings';
      fullPath: '/d/$dictionaryId/settings';
      preLoaderRoute: typeof AppDDictionaryIdSettingsRouteImport;
      parentRoute: typeof AppDDictionaryIdRoute;
    };
    '/_app/d/$dictionaryId/l/$headword': {
      id: '/_app/d/$dictionaryId/l/$headword';
      path: '/l/$headword';
      fullPath: '/d/$dictionaryId/l/$headword';
      preLoaderRoute: typeof AppDDictionaryIdLHeadwordRouteImport;
      parentRoute: typeof AppDDictionaryIdRoute;
    };
    '/_app/d/$dictionaryId/w/$entryId/': {
      id: '/_app/d/$dictionaryId/w/$entryId/';
      path: '/w/$entryId';
      fullPath: '/d/$dictionaryId/w/$entryId/';
      preLoaderRoute: typeof AppDDictionaryIdWEntryIdIndexRouteImport;
      parentRoute: typeof AppDDictionaryIdRoute;
    };
    '/_app/d/$dictionaryId/w/$entryId/edit': {
      id: '/_app/d/$dictionaryId/w/$entryId/edit';
      path: '/w/$entryId/edit';
      fullPath: '/d/$dictionaryId/w/$entryId/edit';
      preLoaderRoute: typeof AppDDictionaryIdWEntryIdEditRouteImport;
      parentRoute: typeof AppDDictionaryIdRoute;
    };
  }
}

interface AppDDictionaryIdRouteChildren {
  AppDDictionaryIdAddRoute: typeof AppDDictionaryIdAddRoute;
  AppDDictionaryIdSearchRoute: typeof AppDDictionaryIdSearchRoute;
  AppDDictionaryIdSettingsRoute: typeof AppDDictionaryIdSettingsRoute;
  AppDDictionaryIdIndexRoute: typeof AppDDictionaryIdIndexRoute;
  AppDDictionaryIdLHeadwordRoute: typeof AppDDictionaryIdLHeadwordRoute;
  AppDDictionaryIdWEntryIdEditRoute: typeof AppDDictionaryIdWEntryIdEditRoute;
  AppDDictionaryIdWEntryIdIndexRoute: typeof AppDDictionaryIdWEntryIdIndexRoute;
}

const AppDDictionaryIdRouteChildren: AppDDictionaryIdRouteChildren = {
  AppDDictionaryIdAddRoute: AppDDictionaryIdAddRoute,
  AppDDictionaryIdSearchRoute: AppDDictionaryIdSearchRoute,
  AppDDictionaryIdSettingsRoute: AppDDictionaryIdSettingsRoute,
  AppDDictionaryIdIndexRoute: AppDDictionaryIdIndexRoute,
  AppDDictionaryIdLHeadwordRoute: AppDDictionaryIdLHeadwordRoute,
  AppDDictionaryIdWEntryIdEditRoute: AppDDictionaryIdWEntryIdEditRoute,
  AppDDictionaryIdWEntryIdIndexRoute: AppDDictionaryIdWEntryIdIndexRoute,
};

const AppDDictionaryIdRouteWithChildren =
  AppDDictionaryIdRoute._addFileChildren(AppDDictionaryIdRouteChildren);

interface AppRouteChildren {
  AppOnboardingRoute: typeof AppOnboardingRoute;
  AppSettingsRoute: typeof AppSettingsRoute;
  AppDDictionaryIdRoute: typeof AppDDictionaryIdRouteWithChildren;
  AppDictionariesNewRoute: typeof AppDictionariesNewRoute;
}

const AppRouteChildren: AppRouteChildren = {
  AppOnboardingRoute: AppOnboardingRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppDDictionaryIdRoute: AppDDictionaryIdRouteWithChildren,
  AppDictionariesNewRoute: AppDictionariesNewRoute,
};

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRoute,
  ShareTokenRoute: ShareTokenRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
